export default __webpack_public_path__ + "app/assets/images/job_offer/thumbnail-live-3eb6676afefe89866d824a4abf55d3c3.jpg";